( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( 'LotUnsavedRemoveDialogController', LotUnsavedRemoveDialogController );

    LotUnsavedRemoveDialogController.$inject = [ 'entity', '$uibModalInstance' ];

    function LotUnsavedRemoveDialogController ( entity, $uibModalInstance ) {

        var vm = this;

        vm.lot = entity;

        vm.close = close;
        vm.confirmDelete = confirmDelete;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            $uibModalInstance.close( true );
        }
        
    }
})();
